import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { FormControl, Select, MenuItem } from '@material-ui/core'
import axios from 'axios'
import jwt from 'jwt-decode'
import { authHeader } from '../../functions/_helpers'

const getRole = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user'))
    return user && user.token ? parseInt(jwt(user.token).role) : 0
  } catch (error) {
    return 0
  }
}

const RegionSelect = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const regionId = useSelector(state => state.dashboard.regionId || 0)
  const regions = useSelector(state => state.dashboard.regions) || []
  const role = getRole()
  const onDashboard = location.pathname === '/' || location.pathname.startsWith('/dashboard')
  const canFilterByRegion = role === 1 || role === 2 || role === 4

  useEffect(() => {
    if (!onDashboard || !canFilterByRegion) return
    axios
      .get(process.env.REACT_APP_API_URL + '/api/dashboard/regions', { headers: authHeader() })
      .then(response => dispatch({ type: 'SET_DASHBOARD', key: 'regions', value: response.data }))
      .catch(error => console.log(error))
  }, [onDashboard, canFilterByRegion, dispatch])

  if (!onDashboard || !canFilterByRegion || (role === 2 && regions.length <= 1)) return null

  return (
    <FormControl style={{ minWidth: 200, margin: '-35px 8px 0 8px' }}>
      <Select
        disableUnderline
        value={regionId}
        onChange={event => dispatch({ type: 'SET_DASHBOARD', key: 'regionId', value: Number(event.target.value) })}
      >
        <MenuItem value={0}>{role === 1 ? 'Alle regioner' : 'Alle mine regioner'}</MenuItem>
        {regions.map(region => (
          <MenuItem key={region.regionId} value={region.regionId}>{region.name}</MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default RegionSelect
